// extracted by mini-css-extract-plugin
module.exports = {"title":"editable-card_title__3r4qR"};